module.exports = __webpack_public_path__ + "img/electronic_electric_use.9409489c.svg";